import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setAmbulanceConditionIndicatorOptions as setAmbulanceConditionIndicatorOptionsAction } from '../store/options.actions'

import { OptionsService } from '../services/options.service'

export function* setAmbulanceConditionIndicatorOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getAmbulanceConditionOptions])
    const { entity } = response
    yield put(setAmbulanceConditionIndicatorOptionsAction(entity))
  } catch (e) {
    yield put(throwPcrException(`setAmbulanceConditionIndicatorOptions() error: ${e}`))
  }
}

export function* setAmbulanceConditionIndicatorOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setAmbulanceConditionIndicatorOptions)
}
